import httpClient from "Api/httpClient";

const END_POINT = "/currencies";

const getCurrencies = (payload) => {
    let body = "";
    if (payload.body) body = payload.body;
    return httpClient.get(END_POINT, { retryTimes: 3, params: body }); // useCahe: true, retryTimes: 3, throttle: true
};

const getCurrency = (currency_id) => {
    if (!currency_id) return;
    const SINGLE_END_POINT = END_POINT + "/" + currency_id;
    return httpClient.get(SINGLE_END_POINT);
};

const printCurrency = (currency_id) => {
    if (!currency_id) return;
    const SINGLE_END_POINT = END_POINT + "/print?currency_id=" + currency_id;
    return httpClient.get(SINGLE_END_POINT);
};

const createCurrencies = (payload) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    return httpClient.post(END_POINT, body);
};

const updateCurrencies = (payload, currency_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const UPDATE_END_POINT = END_POINT + "/" + currency_id;
    return httpClient.patch(UPDATE_END_POINT, body);
};

const deleteCurrencies = (currency_id) => {
    const DELETE_END_POINT = END_POINT + "/" + currency_id;
    return httpClient.delete(DELETE_END_POINT, { retryTimes: 3 });
};

export { getCurrencies, getCurrency, printCurrency, createCurrencies, updateCurrencies, deleteCurrencies };
